import { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { ReactSortable } from "react-sortablejs";
import NewProgram from "../NewProgram/NewProgram";
import TitleDrag from "../TitleDrag/TitleDrag";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
let lastKey = 1000;

const SelectedExcersises = ({ onSave, exercises = [], setExercises }) => {
  // const [exercises, setExercises] = useState([]);

  const deleteItem = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This will remove the program",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-primary-outline",
      },
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        setExercises(exercises.filter((item) => item.id !== id));
      }
    });
  };

  return (
    <>
      <Row>
        <Col className="position-relative">
          {exercises.length <= 0 && <TitleDrag title="Drag & Drop here" />}

          <ReactSortable
            list={exercises}
            setList={setExercises}
            className={"row"}
            group={"shared"}
            clone={(x) => {
              x.id = ++lastKey + "sidebarRightKey";
              return x;
            }}
            className="min-h-300"
          >
            {exercises.map((item) => (
              <div key={`program-${item.id}`}>
                <NewProgram
                  title={item.name}
                  description={item.description}
                  img={item.thumbnail}
                  id={item.id}
                  deleteItem={deleteItem}
                />
              </div>
            ))}
          </ReactSortable>
        </Col>
      </Row>
      <Row className="pt-5 ">
        <Col className="m-0 p-0">
          <Button
            variant="primary"
            className="w-100"
            onClick={() => onSave(exercises)}
            disabled={exercises.length <= 0 ? true : false}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default SelectedExcersises;
